import { FilterFilled, FilterOutlined } from "@ant-design/icons";
import { Checkbox, Dropdown, Menu, Select } from "antd";
import { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { fetchAllProducts } from "../../../store/actions/products";

const { Option } = Select;
export class ProductsSelectWithFilter extends Component {
  state = {
    showOnlyInventoryItems: false,
    selectedCats: [],
  };

  componentDidMount = async () => {
    if (!this.props.products?.length && !this.props.customProducts?.length) {
      await this.props.fetchAllProducts();
    }
  };
  render() {
    const {
      products,
      categories,
      t,
      onSelect,
      config,
      customFilter,
      loading,
      productsLoading,
      customProducts,
    } = this.props;
    const { showOnlyInventoryItems, selectedCats } = this.state;

    let productsList = [];
    (customProducts || products).forEach((product) => {
      if (
        (customFilter?.(product) ?? true) &&
        !product.has_variants &&
        !["bookable", "service"].includes(product.type_of_product) &&
        !product.is_deleted &&
        (!selectedCats.length || selectedCats.includes(product.category_id)) &&
        (!showOnlyInventoryItems || product.is_inventory_item)
      ) {
        productsList.push(
          <Option value={product.id} key={product.id}>
            {config.language == "arabic"
              ? product.ar_name || product.name
              : product.name}
          </Option>
        );
      }
    });

    const selectableCatagories = categories?.map((cat) => ({
      value: cat.id,
      label: config.language === "arabic" ? cat.ar_name || cat.name : cat.name,
    }));

    return (
      <Select
        loading={loading || productsLoading}
        showSearch
        style={{ width: "100%" }}
        placeholder={t("select a product")}
        onSelect={(e) => onSelect(e)}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        suffixIcon={
          loading || productsLoading ? undefined : (
            <Dropdown
              overlay={
                <Menu className="p-2 d-flex flex-column" style={{ gap: 10 }}>
                  {this.props.settings.enable_advanced_inventory_system && (
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          showOnlyInventoryItems: e.target.checked,
                        })
                      }
                    >
                      {t("Show only inventory items")}
                    </Checkbox>
                  )}

                  <Select
                    showSearch
                    placeholder="Select categories"
                    mode="multiple"
                    allowClear={true}
                    onClear={() => this.setState({ selectedCats: null })}
                    onChange={(e) => {
                      this.setState({ selectedCats: e });
                    }}
                    // onDeselect={(e) => this.setState({ selectedCats: e })}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={selectableCatagories}
                    style={{ minWidth: "200px" }}
                  />
                </Menu>
              }
              trigger={["click"]}
              placement="right"
            >
              <div style={{ height: "100%" }}>
                {selectedCats.length || showOnlyInventoryItems ? (
                  <FilterFilled
                    style={{
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#0099CC",
                    }}
                  />
                ) : (
                  <FilterOutlined
                    style={{
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  />
                )}
              </div>
            </Dropdown>
          )
        }
      >
        {productsList}
      </Select>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
  settings: state.auth.settings,
  permissions: state.auth.permissions,
  categories: state.products.categories,
  products: state.products.allProducts,
  productsLoading: state.products.loadingAll,
});

const mapDispatchToProps = (dispatch) => {
  return { fetchAllProducts: () => dispatch(fetchAllProducts()) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ProductsSelectWithFilter));
